import { ActionIcon, Tooltip } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { useState } from 'react';

const copyToClipboard = async (value) => {
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
        return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};

export function CopyableId({ id, label = 'ID', stopPropagation = true }) {
    const [copied, setCopied] = useState(false);
    const value = id ? String(id) : '';

    const handleCopy = async (event) => {
        if (stopPropagation) {
            event.stopPropagation();
        }

        if (!value) return;

        try {
            await copyToClipboard(value);
            setCopied(true);
            notifications.show({
                color: 'green',
                title: `${label} copied`,
                autoClose: 1800
            });
            window.setTimeout(() => setCopied(false), 1400);
        } catch (error) {
            notifications.show({
                color: 'red',
                title: `Could not copy ${label.toLowerCase()}`,
                message: error.message,
                autoClose: 2500
            });
        }
    };

    const Icon = copied ? IconCheck : IconCopy;

    return (
        <Tooltip label={value ? `Copy ${label}` : `No ${label.toLowerCase()}`} withArrow>
            <ActionIcon
                aria-label={`Copy ${label}`}
                color={copied ? 'green' : 'gray'}
                disabled={!value}
                onClick={handleCopy}
                variant="subtle"
            >
                <Icon size={16} stroke={1.8} />
            </ActionIcon>
        </Tooltip>
    );
}
